import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledTabsList = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  border-width: 1px;
  border-style: solid;
  border-color: ${themeGet('colors.text.border')};
  border-radius: ${themeGet('radii.small')};

  &:not(:last-child) {
    margin-bottom: 75px;
  }
`;

export const StyledTab = styled.li<{
  active?: boolean;
}>`
  display: flex;
  flex: auto;
  align-items: center;
  justify-content: center;
  padding: 9px;
  list-style: none;
  line-height: 32px;
  font-size: ${themeGet('fontSizes.md')}px;
  font-weight: ${themeGet('fontWeights.semi')};
  cursor: pointer;
  color: ${(props) =>
    props.active
      ? themeGet('colors.primary.extra')
      : themeGet('colors.input.checkbox')};

  &:not(:last-child) {
    border-right-width: 1px;
    border-right-style: solid;
    border-right-color: #d5d9e7;
  }
`;
